import { Settings } from '@/components/ShopifyProvider/types'
import { GetProductDataResponseNode } from '../../queries/getProductData'
import { ProductHit } from '../../types'

/**
 *  This function checks if a product is available for sale based on stop selling rates
 *  and inventory quantities.
 *
 *  Each product can have a product-level stop selling rate defined by the stop_selling_quantity metafield.
 *  Each store also has a store-level stop selling rate defined in the settings schema.
 *
 * @param {ProductHit} hit - Hit returned from algolia.
 * @param {ResponseNode} node - Node returned from the storefront API.
 * @param {Settings} settings - Settings object from Shopify.
 * @returns {boolean} - True or false depending on if the quantity available is greater than the stop selling rate.
 */
export const getProductAvailability = (
  hit: ProductHit,
  node?: GetProductDataResponseNode,
  settings?: Settings,
): boolean => {
  const { stop_selling_quantity: storeStopSellingQuantity } = settings || {}

  const productStopSellingQuantity = node?.stopSellingQuantity?.value ?? true

  const availableForSale = (node && node.availableForSale) ?? true
  const inventoryQuantity = hit?.inventory_quantity ?? 0

  const hasQuantityAvailable =
    storeStopSellingQuantity !== undefined &&
    typeof productStopSellingQuantity === 'string'
      ? inventoryQuantity > storeStopSellingQuantity &&
        inventoryQuantity > Number(productStopSellingQuantity)
      : true

  return availableForSale && hasQuantityAvailable
}
